import { lazy } from "react";

const SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  login: lazy(() => import("@/screens/LoginScreen")),
  "login-id": lazy(() => import("@/screens/LoginIdScreen")),
  "login-password": lazy(() => import("@/screens/LoginPasswordScreen")),
  "reset-password-email": lazy(
    () => import("@/screens/ResetPasswordEmailScreen")
  ),
  "reset-password": lazy(() => import("@/screens/ResetPasswordScreen")),
  "reset-password-success": lazy(
    () => import("@/screens/ResetPasswordSuccessScreen")
  ),
  "reset-password-error": lazy(
    () => import("@/screens/ResetPasswordErrorScreen")
  ),
  "reset-password-request": lazy(
    () => import("@/screens/ResetPasswordRequestScreen")
  ),
  "signup-id": lazy(() => import("@/screens/SignUpIdScreen")),
  "signup-password": lazy(() => import("@/screens/SignUpPasswordScreen")),
  signup: lazy(() => import("@/screens/SignUpScreen")),
  "mfa-begin-enroll-options": lazy(
    () => import("@/screens/MfaEnrollmentScreen")
  ),
  "mfa-otp-challenge": lazy(() => import("@/screens/MfaChallengeScreen")),
};

export type ScreenName = keyof typeof SCREEN_COMPONENTS;

export const getScreenComponent = (
  screenName: string
): React.ComponentType | null => {
  return SCREEN_COMPONENTS[screenName] || null;
};
